var _line, _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelegate = function SvgDelegate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 30 30",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#b6bbcc"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    stroke: "#b6bbcc",
    strokeWidth: 2,
    strokeLinecap: "round",
    x1: 4,
    x2: 6.5,
    y1: 26,
    y2: 23.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,16l7.414-7.414c0.781-0.781,0.781-2.047,0-2.828l-2.172-2.172c-0.781-0.781-2.047-0.781-2.828,0L14,11L19,16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.761,24.239L17,18c0,0-5-5-5-5l-6.241,6.241c-0.497,0.497-0.854,1.116-1.036,1.795l-0.65,2.429l2.595,2.42l2.291-0.608  C9.641,25.095,10.263,24.737,10.761,24.239z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25,8l1.379-1.379c0.828-0.828,0.828-2.17,0-2.998l-0.002-0.002c-0.828-0.828-2.17-0.828-2.998,0L22,5L25,8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 24,
    r: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22,5l-1.285-1.285  c-0.947-0.947-2.482-0.947-3.429,0L17,4c-1,1-2.5,3.5-4,5",
    stroke: "#b6bbcc",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgDelegate;